export interface Dialog {
  data: DialogData;
}

export interface DialogData {
  message: string;
  buttonText: ButtonText;
}

interface ButtonText {
  cancel: string;
  ok?: string; //AlertDialogComponent does not use the 'ok' button
}

export const DefaultConfirmationDialogData = {
  data: {
    message: "TableTemplate.ConfirmationDialog.Message",
    buttonText: {
      ok: "TableTemplate.ConfirmationDialog.AcceptButton",
      cancel: "TableTemplate.ConfirmationDialog.CancelButton",
    },
  },
};

export const GuardConfirmationDialogData = {
  data: {
    message: "TableTemplate.ConfirmationDialog.GuardMessage",
    buttonText: {
      ok: "TableTemplate.ConfirmationDialog.AcceptButton",
      cancel: "TableTemplate.ConfirmationDialog.CancelButton",
    },
  },
};
